import React, { memo } from 'react';
import propTypes from 'prop-types';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import { cleanseDecimal } from 'src/ui/util';
import { UiInputAdapter, UiFieldset, UiDatePickerAdapter } from 'src/ui';
import dayjs from 'dayjs-ext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function LoanSummaryForm({ className, form }) {
  return (
    <>
      <UiFieldset title="Payment & Closed Date" className={className}>
        <Columns isMultiline>
          <Column isSize="1/3" className="is-one-third-fullhd">
            <Field
              component={UiInputAdapter}
              name="loanIdentifier"
              id={'loanIdentifier' || 'id'}
              label="Loan ID"
            />
          </Column>
          <Column isSize="1/3" className="is-one-third-fullhd">
            <Field
              component={UiDatePickerAdapter}
              name="loanClosedDate"
              id="loanClosedDate"
              label="Loan Closed Date"
              maxDate={dayjs()
                .startOf('day')
                .toDate()}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              hasIcons="right"
              renderIcons={() => [
                <span className="icon is-right" key="right-icon">
                  <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                </span>,
              ]}
            />
          </Column>
          <Column isSize="1/3" className="is-one-third-fullhd">
            <Field
              component={UiInputAdapter}
              name="loanPaymentAmount"
              id="loanPaymentAmount"
              label="Loan Payment Amount $"
              onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
            />
          </Column>
          <Column isSize="1/3" className="is-one-third-fullhd">
            <Field
              component={UiInputAdapter}
              name="loanPaymentMethod"
              id="loanPaymentMethod"
              label="Loan Payment Method"
            />
          </Column>
        </Columns>
      </UiFieldset>
    </>
  );
}

LoanSummaryForm.defaultProps = {
  className: '',
};

LoanSummaryForm.propTypes = {
  className: propTypes.string,
  form: propTypes.object.isRequired,
};

const memoizedLoanSummaryForm = memo(LoanSummaryForm);

export { memoizedLoanSummaryForm as LoanSummaryForm };
